export default function Footer() {
  return (
    <footer className="bg-slate-900 text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* CTA Section */}
        <div className="bg-amber-500 rounded-2xl p-6 sm:p-8 mb-12 text-center">
          <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-slate-900 mb-4">
            Direct een Taxi Reserveren?
          </h3>
          <p className="text-base sm:text-lg text-slate-800 mb-6">
            Bel ons, stuur een WhatsApp of vraag online een prijs aan
          </p>
          <div className="flex flex-wrap justify-center gap-3 sm:gap-4">
            <a href="tel:+31658824429" className="px-6 sm:px-8 py-3 sm:py-4 bg-slate-900 text-white rounded-lg font-semibold hover:bg-slate-800 transition-colors whitespace-nowrap text-sm sm:text-base">
              <i className="ri-phone-line mr-2"></i>Bel Direct
            </a>
            <a href="https://wa.me/31658824429" className="px-6 sm:px-8 py-3 sm:py-4 bg-green-600 text-white rounded-lg font-semibold hover:bg-green-700 transition-colors whitespace-nowrap text-sm sm:text-base">
              <i className="ri-whatsapp-line mr-2"></i>WhatsApp Reserveren
            </a>
            <a href="/prijs-berekenen" className="px-6 sm:px-8 py-3 sm:py-4 bg-white text-slate-900 rounded-lg font-semibold hover:bg-slate-100 transition-colors whitespace-nowrap text-sm sm:text-base">
              <i className="ri-calculator-line mr-2"></i>Prijs Aanvragen
            </a>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <h3 className="text-xl font-bold mb-4">Utrecht Airport Taxi</h3>
            <p className="text-slate-400 mb-4 leading-relaxed">
              Uw betrouwbare taxiservice voor luchthaven vervoer in de regio Utrecht. Vaste prijzen, geen verborgen kosten.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center hover:bg-amber-500 transition-colors">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center hover:bg-amber-500 transition-colors">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center hover:bg-amber-500 transition-colors">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Snelle Links</h4>
            <ul className="space-y-3">
              <li>
                <a href="/" className="text-slate-400 hover:text-amber-500 transition-colors">
                  Home
                </a>
              </li>
              <li>
                <a href="/prijs-berekenen" className="text-slate-400 hover:text-amber-500 transition-colors">
                  Prijs Berekenen
                </a>
              </li>
              <li>
                <a href="/werkgebied" className="text-slate-400 hover:text-amber-500 transition-colors">
                  Werkgebied
                </a>
              </li>
              <li>
                <a href="/taxi-utrecht-schiphol" className="text-slate-400 hover:text-amber-500 transition-colors">
                  Taxi Utrecht Schiphol
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Onze Diensten</h4>
            <ul className="space-y-3">
              <li>
                <a href="/taxi-utrecht-schiphol" className="text-slate-400 hover:text-amber-500 transition-colors">
                  Schiphol Transfer
                </a>
              </li>
              <li>
                <a href="/taxi-utrecht-rotterdam-airport" className="text-slate-400 hover:text-amber-500 transition-colors">
                  Rotterdam Airport
                </a>
              </li>
              <li>
                <a href="/taxi-utrecht-eindhoven-airport" className="text-slate-400 hover:text-amber-500 transition-colors">
                  Eindhoven Airport
                </a>
              </li>
              <li>
                <a href="/werkgebied" className="text-slate-400 hover:text-amber-500 transition-colors">
                  Lokale Ritten
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <i className="ri-phone-fill text-amber-500 mt-1"></i>
                <div>
                  <p className="text-slate-400 text-sm">Telefoon</p>
                  <a href="tel:0612345678" className="text-white hover:text-amber-500 transition-colors">
                    06 1234 5678
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-whatsapp-fill text-amber-500 mt-1"></i>
                <div>
                  <p className="text-slate-400 text-sm">WhatsApp</p>
                  <a href="https://wa.me/31658824429?text=Hallo,%20ik%20wil%20graag%20een%20taxi%20boeken%20naar%20de%20luchthaven." target="_blank" rel="noopener noreferrer" className="text-white hover:text-amber-500 transition-colors">
                    06 5882 4429
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-mail-fill text-amber-500 mt-1"></i>
                <div>
                  <p className="text-slate-400 text-sm">E-mail</p>
                  <a href="mailto:info@utrechtairporttaxi.nl" className="text-white hover:text-amber-500 transition-colors">
                    info@utrechtairporttaxi.nl
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-400 text-sm">
              © 2024 Utrecht Airport Taxi. Alle rechten voorbehouden. KvK: [KVK NUMMER]
            </p>
            <div className="flex flex-wrap gap-6 text-sm">
              <a href="/privacy" className="text-slate-400 hover:text-amber-500 transition-colors">
                Privacybeleid
              </a>
              <a href="/cookies" className="text-slate-400 hover:text-amber-500 transition-colors">
                Cookiebeleid
              </a>
              <a href="/algemene-voorwaarden" className="text-slate-400 hover:text-amber-500 transition-colors">
                Algemene Voorwaarden
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
